import React from 'react'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { AGE_BAND_OPTIONS } from '../../../_pewsCalc'

// Shown only when the patient's DOB is unknown but they are flagged as under
// 18 — the estimated age group picks which PEWS chart the score runs against
const EstimatedAgeBand = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>Estimated Age Group</InputLabel>
      <Select value={value} onChange={onChange} label="Estimated Age Group">
        {AGE_BAND_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default EstimatedAgeBand
